<template>
  <div class="category-carousel">
    <div class="image-column">
      <img :src="requireMedia(activeSlide.image)"/>
    </div>
    <div class="text-column">
            <span class="close" @click.prevent.stop="$emit('close')">
                <img :src="requireMedia('icons_UI_icon_X.svg')"/>
            </span>
      <div class="headline">
        {{ activeSlide.title }}
      </div>
      <div class="facts">
        <ul>
          <li>
            <img class="perspective-icon"
                 :src="requireMedia(isCar() ? 'icons_illu_auto_hoehe.svg' : 'icons_fahrrad_mint.svg' )"> Perspektive
            {{ isCar() ? 'Auto' : 'Fahrrad' }}
          </li>
          <li>
            <img class="perspective-icon" :src="requireMedia('icons_attention_mint.svg' )"> Situation <span
              v-if="isMissed()">nicht</span> erkannt
          </li>
          <li>
            <img class="perspective-icon" :src="requireMedia(answerIcon())">
            <span v-if="isCorrect()"> Frage richtig beantwortet</span>
            <span v-if="isMissed()"> Frage verpasst</span>
            <span v-if="!isCorrect() && !isMissed()"> Frage falsch beantwortet</span>
          </li>
        </ul>
      </div>
      <div class="explanation">
        {{ activeSlide.explanation }}
      </div>
      <a target="_blank" @click="openLink(activeSlide.link.url)" :href="activeSlide.link.url"
         class="link">{{ activeSlide.link.label }} <img :src="requireMedia('icons_UI_outlink.svg')"></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryCarousel",
  props: {
    activeSlide: Object,
    result: Object,
  },
  data() {
    return {}
  },
  mounted() {

  },
  methods: {
    openLink(to) {
      window.open(to);
    },
    requireMedia(image) {
      return require('../../assets/' + image);
    },
    isCar() {
      return this.result[this.activeSlide.id].perspective === 'car';
    },
    isCorrect() {
      return this.result[this.activeSlide.id].correct;
    },
    isMissed() {
      return this.result[this.activeSlide.id].missed;
    },
    answerIcon() {
      let iconSuffix = 'check_mint';
      let answer = this.result[this.activeSlide.id];
      if (answer.missed) iconSuffix = 'missed_mint';
      if (answer.correct === false && answer.missed === false) iconSuffix = 'X_auswertung';
      return 'icons_UI_icon_' + iconSuffix + '.svg'
    }
  }
}
</script>

<style lang="scss" scoped>

.facts {
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}

.link {
  text-decoration: none;
  text-transform: uppercase;
  color: #FFF;
  position: absolute;
}

.text-column {
  top: 0;
  position: relative;
  background-color: rgb(38, 38, 38);
}

.image-column {
  top: 0;
  left: 0;
  position: relative;
  background-color: rgb(38, 38, 38);
}

.category-carousel {
  z-index: 120;
  position: absolute;
  background-color: transparent;
  display: flex;
  color: #fff;
  overflow: hidden;
}

.close {
  cursor: pointer;
  position: absolute;
}

$vhUnit: 9;
$vwUnit: 16;
$vhUnitMobile: 3.75;
$vwUnitMobile: 6.66;

@function scaleVh($size) {
  @return #{($size/$vhUnit)}vh;
}
@function scaleVw($size) {
  @return #{($size/$vwUnit)}vw;
}
@function scaleMobileVh($size) {
  @return #{($size/$vhUnitMobile)}vh;
}
@function scaleMobileVw($size) {
  @return #{($size/$vwUnitMobile)}vw;
}

@media(min-aspect-ratio: 16/9) {

  .close {
    top: scaleVh(17);
    left: scaleVh(383);

    img {
      width: scaleVh(19.2);
      height: scaleVh(19.2);
    }
  }

  .link img {
    width: scaleVh(15);
    height: scaleVh(12);
  }

  .headline {
    font-size: scaleVh(25);
  }
  .facts {
    margin-top: scaleVh(6);
    font-size: scaleVh(14);

    .perspective-icon {
      width: scaleVh(32);
      height: scaleVh(20);
      margin-right: scaleVh(18);
    }

    li {
      margin-top: scaleVh(5);
      line-height: scaleVh(20);
      height: scaleVh(21);
    }
  }
  .explanation {
    margin-top: scaleVh(10);
    font-size: scaleVh(14);
    line-height: scaleVh(20);
  }
  .link {
    font-size: scaleVh(16);
    font-weight: bold;
    bottom: scaleVh(30);
  }

  .category-carousel {
    top: scaleVh(214);
    /*1600 - 818(breite) / 2*/
    left: scaleVh(391);
    width: scaleVh(818);
    height: scaleVh(393);
    border-radius: scaleVh(16);
    border: scaleVh(0.001) solid;
    border-color: rgba(25, 25, 25, 0);
  }

  .image-column, .image-column img {
    height: scaleVh(393);
    width: scaleVh(393);
  }

  .text-column {
    height: scaleVh(393);
    width: scaleVh(425);
    padding: scaleVh(28) scaleVh(34) scaleVh(28) scaleVh(62);
  }

  // mobile ---

  .mobile {
    .close {
      top: scaleMobileVh(5);
      left: scaleMobileVh(280);
      img {
        width: scaleMobileVh(10);
        height: scaleMobileVh(10);
      }
    }
    .link img {
      width: scaleMobileVh(10);
      height: scaleMobileVh(10);
    }
    .headline {
      font-size: scaleMobileVh(20);
    }
    .facts {
      margin-top: scaleMobileVh(10);
      font-size: scaleMobileVh(12);
      .perspective-icon {
        width: scaleMobileVh(16);
        height: scaleMobileVh(10);
        margin-right: scaleMobileVh(2);
      }
      li {
        display: inline;
        padding-right: scaleMobileVh(10);
        margin-top: auto;
        line-height: scaleMobileVh(18);
        height: auto;
      }
    }
    .explanation {
      margin-top: scaleMobileVh(10);
      font-size: scaleMobileVh(12);
      line-height: scaleMobileVh(15);
    }
    .link {
      font-size: scaleMobileVh(12);
      bottom: scaleMobileVh(20);
    }
    .category-carousel {
      left: scaleMobileVh(51);
      top: scaleMobileVh(52);
      width: scaleMobileVh(564);
      height: scaleMobileVh(255);
    }
    .image-column,
    .image-column img {
      height: scaleMobileVh(255);
      width: scaleMobileVh(264);
    }
    .text-column {
      height: scaleMobileVh(255);
      width: scaleMobileVh(300);
      padding: scaleMobileVh(10) scaleMobileVh(20) scaleMobileVh(20) scaleMobileVh(20);
    }
  }
}

@media(max-aspect-ratio: 16/9) {

  .close {
    top: scaleVw(17);
    left: scaleVw(383);

    img {
      width: scaleVw(19.2);
      height: scaleVw(19.2);
    }
  }
  .link img {
    width: scaleVw(15);
    height: scaleVw(12);
  }
  .headline {
    font-size: scaleVw(25);
  }
  .facts {
    margin-top: scaleVw(6);
    font-size: scaleVw(14);

    .perspective-icon {
      margin-right: scaleVw(18);
      width: scaleVw(32);
      height: scaleVw(20);
    }

    li {
      margin-top: scaleVw(5);
      line-height: scaleVw(20);
      height: scaleVw(21);
    }
  }
  .explanation {
    margin-top: scaleVw(10);
    font-size: scaleVw(14);
    line-height: scaleVw(20);
  }
  .link {
    /*margin-top: scaleVh(39);*/
    font-size: scaleVw(16);
    font-weight: bold;
    bottom: scaleVw(30);
  }

  .category-carousel {
    top: scaleVw(214);
    /*1600 - 818(breite) / 2*/
    left: scaleVw(391);
    width: scaleVw(818);
    height: scaleVw(393);
  }

  .image-column, .image-column img {
    height: scaleVw(393);
    width: scaleVw(393);
  }

  .text-column {
    height: scaleVw(393);
    width: scaleVw(425);
    padding: scaleVw(28) scaleVw(34) scaleVw(28) scaleVw(62);
  }

  .mobile {
    .close {
      top: scaleMobileVw(5);
      left: scaleMobileVw(280);
      img {
        width: scaleMobileVw(10);
        height: scaleMobileVw(10);
      }
    }
    .link img {
      width: scaleMobileVw(10);
      height: scaleMobileVw(10);
    }
    .headline {
      font-size: scaleMobileVw(20);
    }
    .facts {
      margin-top: scaleMobileVw(10);
      font-size: scaleMobileVw(12);
      .perspective-icon {
        width: scaleMobileVw(16);
        height: scaleMobileVw(10);
        margin-right: scaleMobileVw(2);
      }
      li {
        display: inline;
        padding-right: scaleMobileVw(10);
        margin-top: auto;
        line-height: scaleMobileVw(18);
        height: auto;
      }
    }
    .explanation {
      margin-top: scaleMobileVw(10);
      font-size: scaleMobileVw(12);
      line-height: scaleMobileVw(15);
    }
    .link {
      font-size: scaleMobileVw(12);
      bottom: scaleMobileVw(20);
    }
    .category-carousel {
      left: scaleMobileVw(51);
      top: scaleMobileVw(52);
      width: scaleMobileVw(564);
      height: scaleMobileVw(255);
    }
    .image-column,
    .image-column img {
      height: scaleMobileVw(255);
      width: scaleMobileVw(264);
    }
    .text-column {
      height: scaleMobileVw(255);
      width: scaleMobileVw(300);
      padding: scaleMobileVw(10) scaleMobileVw(20) scaleMobileVw(20) scaleMobileVw(20);
    }
  }
}

</style>